export enum VirtualBackgroundType {
    None = 'none',
    Blur = 'blur',
    Image = 'image'
}